import React from "react";
import "./styles.scss";

const RequestIdCard = ({ title, description }) => {
  return (
    <div className="request-id-card-continer">
      <div className="request-id-title">{title}</div>
      <label className="request-id-description">{description}</label>
    </div>
  );
};

export default RequestIdCard;
